import { render, staticRenderFns } from "./LottoInfo.vue?vue&type=template&id=9ff2ae34&scoped=true&"
import script from "./LottoInfo.vue?vue&type=script&lang=js&"
export * from "./LottoInfo.vue?vue&type=script&lang=js&"
import style0 from "./LottoInfo.vue?vue&type=style&index=0&id=9ff2ae34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff2ae34",
  null
  
)

export default component.exports